export default __webpack_public_path__ + "static/media/pakcable.497b4e99.jpg";